export enum ReconciliationItemStatus {
    Pending = 1,
    CompleteExisting = 2,
    CompleteNew = 3
}